/* eslint-disable import/prefer-default-export */
export const styles = theme => ({
  input: {
    backgroundColor: 'transparent',
    margin: '0 0 20px',
    width: '100%', // added (muiv7)
    maxWidth: 'var(--nae-form-max-width, 50rem)',
    minWidth: theme.spacing(25),
    borderRadius: theme.spacing(0.3),
    [theme.breakpoints.up('sm')]: {
      margin: '0 10px 20px',
    },
    '& .MuiInputBase-root': {
      backgroundColor: theme.palette.common.white,
      borderRadius: theme.spacing(0.3),
    },
  },
  validInput: {
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderStyle: 'solid',
      },
      '&.Mui-focused fieldset': {
        borderStyle: 'solid',
        borderColor: theme.palette.secondary.main,
      },
    },
    '& label.Mui-focused': {
      borderColor: theme.palette.secondary.main,
      color: theme.palette.text.primary,
    },
  },
  inValidInput: {
    color: theme.palette.error.main,
    '& .MuiOutlinedInput-root': {
      '&.Mui-focused fieldset': {
        borderStyle: 'solid',
        borderColor: theme.palette.error.main,
      },
    },
    '& label.Mui-focused': {
      borderColor: theme.palette.error.main,
      color: theme.palette.error.main,
    },
  },
  characterCount: {
    color: theme.palette.text.hint,
    position: 'absolute',
    bottom: 0,
    right: 0,
    fontSize: theme.spacing(1),
    margin: theme.spacing(1),
  },
  characterCountInvalid: {
    color: theme.palette.error.main,
  },
  alert: {
    maxWidth: 'var(--nae-form-max-width, 50rem)',
  },
});
